jQuery( document ).ready(function() {
    if($('.formulairedynamique').length > 0) {

        // document.addEventListener( 'wpcf7mailsent', function( event ) {
        //   gtag('event', 'conversion', {'send_to': 'AW-791818182/JWHTCLmTgdEBEMbfyPkC'});
        //   fbq('track', 'FormulaireCovid');
        //   gtag('event', 'click', {event_category: 'formulaire_covid'});

        //   console.log("gtag('event', 'conversion', {'send_to': 'AW-791818182/JWHTCLmTgdEBEMbfyPkC'});");
        //   console.log("fbq('track', 'FormulaireCovid');");
        //   console.log("gtag('event', 'click', {event_category: 'formulaire_covid'});");
        // }, false );

        $('.m2_image').css('width', '80%');

        var conditionalForm_button_suivant = $('.conditionalForm_button_suivant');
        conditionalForm_button_suivant.click(function(e) {
            e.preventDefault();
            $('html,body').animate({scrollTop: $("#topForm").offset().top - 80}, 'slow');
        });

        // LE FIL D'ARIANE
        var conditionalForm_ariane_ul_besoin = $('.conditionalForm_ariane_ul_besoin'),
        conditionalForm_ariane_ul_santeInfectieuse = $('.conditionalForm_ariane_ul_santeInfectieuse'),
        conditionalForm_ariane_ul_santePhysique = $('.conditionalForm_ariane_ul_santePhysique'),
        conditionalForm_ariane_ul_santePsychologique = $('.conditionalForm_ariane_ul_santePsychologique'),
        conditionalForm_ariane_ul_bilan = $('.conditionalForm_ariane_ul_bilan');
        conditionalForm_ariane_ul_besoin.addClass("ariane_li-selected");
        // LES BLOCS
        var conditionalForm_besoin         = $('.conditionalForm_besoin'),
        conditionalForm_santeInfectieuse   = $('.conditionalForm_santeInfectieuse'),
        conditionalForm_santePhysique      = $('.conditionalForm_santePhysique'),
        conditionalForm_santePsychologique = $('.conditionalForm_santePsychologique'),
        conditionalForm_bilan              = $('.conditionalForm_bilan');
        conditionalForm_santeInfectieuse.css("display", "none");
        conditionalForm_santePhysique.css("display", "none");
        conditionalForm_santePsychologique.css("display", "none");
        conditionalForm_bilan.css("display", "none");
        // LES BOUTONS
        var conditionalForm_accesBilan                  = $('.conditionalForm_accesBilan'),
            conditionalForm_santeInfectieuse_suivant    = $('.conditionalForm_santeInfectieuse_suivant'),
            conditionalForm_santePhysique_suivant       = $('.conditionalForm_santePhysique_suivant'),
            conditionalForm_santePsychologique_suivant  = $('.conditionalForm_santePsychologique_suivant'),
            conditionalForm_bilan_envoyer               = $('.conditionalForm_bilan_envoyer');

        function changeForm(formArrive, liArrive) {
        $('.conditionalForm_bloc').css("display", "none");
        $('.conditionalForm_ariane_ul li').removeClass("ariane_li-selected");
        formArrive.css("display", "block");
        liArrive.addClass("ariane_li-selected");
        }

        conditionalForm_accesBilan.click(function(e) {
        e.preventDefault();
        changeForm(conditionalForm_santeInfectieuse, conditionalForm_ariane_ul_santeInfectieuse);
        });
        conditionalForm_santeInfectieuse_suivant.click(function(e) {
        e.preventDefault();
        changeForm(conditionalForm_santePhysique, conditionalForm_ariane_ul_santePhysique);
        });
        conditionalForm_santePhysique_suivant.click(function(e) {
        e.preventDefault();
        changeForm(conditionalForm_santePsychologique, conditionalForm_ariane_ul_santePsychologique);
        });
        conditionalForm_santePsychologique_suivant.click(function(e) {
        e.preventDefault();
        changeForm(conditionalForm_bilan, conditionalForm_ariane_ul_bilan);
        });

        conditionalForm_bilan_envoyer.click(function(e) {
        e.preventDefault();
        alert("envoyé !");
        });

        conditionalForm_ariane_ul_besoin.click(function(){
        changeForm(conditionalForm_besoin, conditionalForm_ariane_ul_besoin);
        });

        conditionalForm_ariane_ul_santeInfectieuse.click(function(){
        changeForm(conditionalForm_santeInfectieuse, conditionalForm_ariane_ul_santeInfectieuse);
        });

        conditionalForm_ariane_ul_santePhysique.click(function(){
        changeForm(conditionalForm_santePhysique, conditionalForm_ariane_ul_santePhysique);
        });

        conditionalForm_ariane_ul_santePsychologique.click(function(){
        changeForm(conditionalForm_santePsychologique, conditionalForm_ariane_ul_santePsychologique);
        });

        conditionalForm_ariane_ul_bilan.click(function(){
        changeForm(conditionalForm_bilan, conditionalForm_ariane_ul_bilan);
        });

        $('input[name="manifestations_douloureuses"]').change(function(){
        if( $(this).val() == "Oui" ){
            $('textarea[name="manifestations_douloureuses_description"]').parent().parent().css('display', 'block');
        }else {
            $('textarea[name="manifestations_douloureuses_description"]').parent().parent().css('display', 'none');
        }
        });

        $('input[name="troubles_alimentation"]').change(function(){
        if( $(this).val() == "Oui" ){
            $('textarea[name="troubles_alimentation_description"]').parent().parent().css('display', 'block');
        }else {
            $('textarea[name="troubles_alimentation_description"]').parent().parent().css('display', 'none');
        }
        });

        $('input[name="difficultes_mouvements"]').change(function(){
        if( $(this).val() == "Oui" ){
            $('textarea[name="difficultes_mouvements_description"]').parent().parent().css('display', 'block');
        }else {
            $('textarea[name="difficultes_mouvements_description"]').parent().parent().css('display', 'none');
        }
        });

        $('input[name="manifestations_psychologiques"]').change(function(){
        if( $(this).val() == "Oui" ){
            $('textarea[name="manifestations_psychologiques_description"]').parent().parent().css('display', 'block');
        }else {
            $('textarea[name="manifestations_psychologiques_description"]').parent().parent().css('display', 'none');
        }
        });

        $('input[name="troubles_sommeil"]').change(function(){
        if( $(this).val() == "Oui" ){
            $('textarea[name="troubles_sommeil_description"]').parent().parent().css('display', 'block');
        }else {
            $('textarea[name="troubles_sommeil_description"]').parent().parent().css('display', 'none');
        }
        });

        $('input[name="troubles_digestifs"]').change(function(){
        if( $(this).val() == "Oui" ){
            $('textarea[name="troubles_digestifs_description"]').parent().parent().css('display', 'block');
        }else {
            $('textarea[name="troubles_digestifs_description"]').parent().parent().css('display', 'none');
        }
        });




        $('.conditionalForm_santeInfectieuse').find('input').change(function(){
        var score = 0;
        var temperature = $('.conditionalForm_santeInfectieuse').find('input[name="temperature"]').val();
        temperature = parseInt(temperature);
        var fievre = $('input[name="sensation_fievreuse"]:checked').val();
        var maux_tete = $('input[name="maux_tete"]:checked').val();
        var courbature = $('input[name="courbature"]:checked').val();
        var toux = $('input[name="toux"]:checked').val();
        var essoufflement = $('input[name="essoufflement"]:checked').val();
        var digestifs = $('input[name="digestifs"]:checked').val();
        var perte_gout = $('input[name="perte_gout"]:checked').val();

        if(temperature >= 38) {
            score += 2;
        }

        if(fievre == "Oui"){
            score += 1;
        }
        if(maux_tete == "Oui"){
            score += 1;
        }
        if(courbature == "Oui"){
            score += 1;
        }
        if(toux == "Oui"){
            score += 1;
        }
        if(essoufflement == "Oui"){
            score += 3;
        }
        if(digestifs == "Oui"){
            score += 1;
        }
        if(perte_gout == "Oui"){
            score += 2;
        }

        var nbQuestions = $('.conditionalForm_santeInfectieuse').find('input:checked').length;
        
        $('.resultat_du_bilan').css('display', 'block');

        if(score == 0 && nbQuestions > 6){
            $('.grand').css('display', 'none');
            $('.petit').css('display', 'none');
            $('.coroninfo').css('display', 'none');
            $('.rien').css('display', 'block');
        }
        else if(score<3 && nbQuestions > 6) {
            $('.grand').css('display', 'none');
            $('.petit').css('display', 'block');
            $('.coroninfo').css('display', 'none');
            $('.rien').css('display', 'none');
        }else if( score >=3 ){
            $('.grand').css('display', 'block');
            $('.petit').css('display', 'none');
            $('.coroninfo').css('display', 'none');
            $('.rien').css('display', 'none');
        }else {
            $('.grand').css('display', 'none');
            $('.petit').css('display', 'none');
            $('.coroninfo').css('display', 'block');
            $('.rien').css('display', 'none');
        }

        });

        $('.checkbox').click(function(){
        $('.medecin').css('display', 'flex');
        });

        $('textarea').keyup(function(){
        // console.log( $( this ).val().length );
        $( this ).parent().parent().find('.conditionalForm_bloc_textarea_compteur').html( $( this ).val().length + "/" + $(this).attr('maxlength') );
        });

    }
});